import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
    query assistancesWithPagination ($page: Int!, $perPage: Int!, $filters: FiltersAssistance!) {
        assistancesWithPagination (page: $page, first: $perPage, filters: $filters) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                user_id
                userCreation {
                    id
                    name
                    email
                }
                employee_id
                employee {
                    id
                    name
                    last_name
                    mothers_last_name
                    document_type
                    document_number
                }
                date
                checkin_time
                checkout_time
                absence
                reason_absence
                reason_text
                type
                type_text
            }
        }
    }
`

const GET_ALL = gql`
    query assistances ($filters: FiltersAssistance!) {
        assistances (filters: $filters) {
            id
            user_id
            userCreation {
                id
                name
                email
            }
            employee_id
            employee {
                id
                name
                last_name
                document_type
                document_number
                mothers_last_name
                assignment {
                    area {
                        name
                    }
                    sub_area {
                        id
                        name
                        description
                        is_active
                        status_text
                        is_group_piecework
                    }
                }
            }
            date
            checkin_time
            checkout_time
            absence
            reason_absence
            reason_text
            type
            type_text 
            id2
        }
    }
`

const GET_ASSISTANCE_DEVICE = gql`
    query assistanceDevices ($deviceId: ID!, $start: Date!, $end: Date!) {
        assistanceDevices (deviceId: $deviceId, start: $start, end: $end) {
            success
            error
            msg
            assistance {
                uid
                date
                time
                type
                employee_id
                nameUser
                isRegistered
                employee {
                    id
                    uid
                    name
                    last_name
                    mothers_last_name
                    document_number
                    email
                }
            }
        }
    }
`

/**
 * Mutations
 */
 const CREATE = gql`
    mutation createAssistance ($input: AssistanceInput!) {
        createAssistance (input: $input) {
            id
            employee_id
        }
    }
`

const UPDATE = gql`
    mutation updateAssistance ($id: ID!, $input: AssistanceInput!) {
        updateAssistance (id: $id, input: $input) {
            id
            employee_id
        }
    }
`

const DELETE = gql`
 mutation deleteAssistance ($id: ID!) {
    deleteAssistance (id: $id) {
         id
     }
 }
`
const IMPORT_FILE = gql`
    mutation importAssistance ($input: ImportAssistanceInput!) {
        importAssistance (input: $input) {
            success
            msg
        }
    }
`

const SAVE_ASSITANCE_DEVICE = gql`
    mutation saveAssitanceDevice ($input: AssistanceDeviceSave!) {
        saveAssitanceDevice (input: $input) {
            id
        }
    }
`

const PROCESS_ASSISTS_FROM_DEVICE = gql`
    mutation importAssistanceDevice ($input: ImportAssistanceDeviceInput!) {
        importAssistanceDevice (input: $input) {
            uid
            date
            time
            type
            employee_id
            employee {
                id
                name
                email
                uid
            }
            nameUser
            isRegistered
        }
    }
`

export {
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    IMPORT_FILE,
    GET_ASSISTANCE_DEVICE,
    SAVE_ASSITANCE_DEVICE,
    PROCESS_ASSISTS_FROM_DEVICE,
    GET_ALL
}
